import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { showSuccessSnackbar } from 'modules/snackbar';
import { paramConverter, Validator } from 'modules/common';
import { register, getUserInfoForNo } from 'lib/api/member';

import JoinForm from './JoinForm';

const Join = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [errorMessage] = React.useState({});
  const initError = {
    userNo: false,
    userId: false,
    hiwkId: false,
    userName: false,
    email: false,
    password: false,
    confirmPassword: false,
    phoneNumber: false,
  };
  const [error, setError] = React.useState(initError);
  const initParams = {
    userNo: '',
    userId: '',
    hiwkId: '',
    userName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    gubun: '11',
  };
  const [params, setParams] = useState(initParams);
  const [open, setOpen] = useState(false);

  const getParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      let newError = { ...error };
      if (name === 'phoneNumber') {
        const isHyphen = newParams['phoneNumber'].includes('-');
        if (isHyphen) {
          newParams['phoneNumber'] = newParams['phoneNumber']
            .split('-')
            .join('');
        }
        const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
        if (regPhone.test(newParams['phoneNumber'])) {
          newError = { ...newError, phoneNumber: false };
        } else {
          newError = { ...newError, phoneNumber: true };
        }
      }
      if (name === 'password' || name === 'confirmPassword') {
        if (name === 'password') {
          const passwordRegexp =
            // eslint-disable-next-line
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&\^\(\)])[A-Za-z\d$@$!%*#?&\^\(\)]{8,14}$/.test(
              newParams['password']
            );
          if (!passwordRegexp) {
            newError = { ...newError, password: true };
          } else {
            newError = { ...newError, password: false };
          }
        } else if (name === 'confirmPassword') {
          const cPasswordRegexp =
            // eslint-disable-next-line
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&\^\(\)])[A-Za-z\d$@$!%*#?&\^\(\)]{8,14}$/.test(
              newParams['confirmPassword']
            );
          if (!cPasswordRegexp) {
            newError = { ...newError, confirmPassword: true };
          } else {
            newError = { ...newError, confirmPassword: false };
          }
        }
        if (!!newParams['password'] && !!newParams['confirmPassword']) {
          if (newParams['password'] !== newParams['confirmPassword']) {
            newError = { ...newError, password: true, confirmPassword: true };
            handleClickSnackbar({
              message: t('비밀번호를 동일하게 입력해주세요.'),
              option: { type: 'error' },
            });
          } else {
            if (
              newParams['password'].length ===
              newParams['confirmPassword'].length
            ) {
              if (
                newParams['password'].length > 8 &&
                newParams['password'].length < 14
              ) {
                newError = {
                  ...newError,
                  password: false,
                  confirmPassword: false,
                };
              } else {
                newError = {
                  ...newError,
                  password: true,
                  confirmPassword: true,
                };
                handleClickSnackbar({
                  message: t('비밀번호를 확인해주세요.'),
                  option: { type: 'error' },
                });
              }
            }
          }
        }
      }
      setParams(newParams);
      setError(newError);
    }
  };

  /**
   * 등록 버튼
   */
  const handleSubmit = () => {
    let validator = false;
    validator = Validator(paramConverter(params), error);
    console.log('validator => ');

    if (validator.state) {
      handleClickSnackbar({
        message: t('회원가입 정보를 확인해주세요.'),
        option: { type: 'error' },
      });
    } else {
      register({
        user_no: params['userNo'],
        password: params['password'],
        password_confirmation: params['confirmPassword'],
        phone: params['phoneNumber'],
        gubun: params['gubun'],
      })
        .then((response) => {
          const { success } = response.data;
          if (success) {
            console.log('success');
            setOpen(true);
          } else {
            handleClickSnackbar({
              message: t('확인 요망'),
              option: { type: 'error' },
            });
          }
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: { type: 'error' },
          });
        });
    }
  };

  const checkUserNo = () => {
    if (!!params['userNo']) {
      getUserInfoForNo({ user_no: params['userNo'] })
        .then((response) => {
          const { EMAIL, HIWK_ID, USER_ID, USER_NAME } = response.data.data;
          handleClickSnackbar({
            message: t('조회가 완료되었습니다.'),
            option: { type: 'success' },
          });
          getParam({
            ...params,
            email: EMAIL,
            hiwkId: HIWK_ID,
            userId: USER_ID,
            userName: USER_NAME,
          });
        })
        .catch((error) => {
          handleClickSnackbar({ message: error, option: { type: 'error' } });
          getParam({
            ...params,
            email: '',
            hiwkId: '',
            userId: '',
            userName: '',
          });
        });
    } else {
      handleClickSnackbar({
        message: t('사번을 입력해주세요.'),
        option: { type: 'error' },
      });
    }
  };

  const editUserNo = () => {
    getParam(initParams, 'userNo');
  };

  const closeCallBack = () => {
    window.location.replace('/');
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <JoinForm
        open={open}
        getParam={getParam}
        params={params}
        checkUserNo={checkUserNo}
        editUserNo={editUserNo}
        error={error}
        onSubmit={handleSubmit}
        errorMessage={errorMessage}
        closeCallBack={closeCallBack}
      />
    </>
  );
};

export default withRouter(Join);
